// Itinerary-item title/description columns hold a plain string, a localized
// array of { languageCode, text } entries (legacy wire shape), or a
// `{ languageCode: text }` map (e.g. `{ en: '...' }`, written by
// promote-planner-draft.ts and toLegacyLocalizedText's object branch — see
// apps/itineraries/api/src/shared/legacy-localized-text.ts). One resolver
// for every consumer (CMS item sync, customer preview read model) so "which
// language wins" can never drift between them: exact language match first,
// then the first non-empty entry.

type LocalizedTextEntry = { languageCode?: string; text?: string };

export function pickLocalizedText(
  value: unknown,
  preferLanguage = 'en'
): string | null {
  if (typeof value === 'string' && value.trim()) return value.trim();
  if (Array.isArray(value)) {
    const entries = value as LocalizedTextEntry[];
    const preferred = entries.find(
      (e) => e.languageCode?.toLowerCase() === preferLanguage.toLowerCase()
    )?.text;
    if (preferred?.trim()) return preferred.trim();
    for (const e of entries) {
      if (e.text?.trim()) return e.text.trim();
    }
    return null;
  }
  if (value && typeof value === 'object') {
    const map = value as Record<string, unknown>;
    const preferred = map[preferLanguage];
    if (typeof preferred === 'string' && preferred.trim()) {
      return preferred.trim();
    }
    for (const entry of Object.values(map)) {
      if (typeof entry === 'string' && entry.trim()) return entry.trim();
    }
    return null;
  }
  return null;
}
